import { LinearProgress } from '@mui/material';

import { withStyles } from 'tss-react/mui';

const ProgressBar = withStyles(LinearProgress, () => ({
  root: {
    height: '8px',
    left: 0,
  },
}));

export type ProgressSummaryBarProps = {
  percent: number;
};

export const ProgressSummaryBar: React.VFC<ProgressSummaryBarProps> = ({ percent }) => (
  <ProgressBar
    variant="determinate"
    value={percent}
    color="secondary"
  />
);
